import React, { useState } from 'react';
import { Info, ChevronDown, ChevronUp, Heart, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';
import ChatBot from '../chat/ChatBot';

export default function Footer() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);
  const currentYear = new Date().getFullYear();

  const shortText = "The portal is under development...";
  const fullText = "The portal is under development and currently undergoing human verification for AI generated content. For all medical assistance please reach out to your healthcare provider.";

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-t border-gray-200 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-3 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-sm text-gray-600 relative group">
            <Info className="w-4 h-4 text-mint-600 flex-shrink-0" />
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center gap-1 hover:text-gray-900 transition-colors"
            >
              <p>{isExpanded ? fullText : shortText}</p>
              {isExpanded ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
          </div>
          <div className="text-sm flex items-center gap-4">
            <span className="text-gray-500">© {currentYear}</span>
            <a href="https://gprov.com" className="text-mint-600 hover:text-mint-700 transition-colors">
              Gprov.com
            </a>
            <span className="text-gray-400">|</span>
            <span className="flex items-center gap-1">
              Powered by
              <a href="https://kollitech.com" className="text-mint-600 hover:text-mint-700 transition-colors">
                Kollitech.com
              </a>
            </span>             <span className="text-gray-400">|</span>  
            <button
              onClick={() => setShowChatbot(!showChatbot)}
              className="flex items-center gap-2 text-mint-600 hover:text-mint-700 transition-colors"
            >
              <MessageSquare className="w-4 h-4" />
              Talk with IPPA
            </button>
            </div>
        </div>
      </div>
      {showChatbot && <ChatBot onClose={() => setShowChatbot(false)} />}
    </footer>
  );
}
